let lazyLoad;
import {initLazyLoad} from './components/lazyload';
import {topOfferSlider} from './components/slick-slider/top-offer-slider';

const ready = async (callback) => {
    if (document.readyState !== "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
};
const registerSwitcher = () => {
    const switchInputs = (value) => {
        try {
            const el1 = document.querySelector('.js-registrationType-dynamic[data-hide*=' + value + ']')
            if (el1) {
                el1.style.display = 'none'
            }
            const el2 = document.querySelector('.js-registrationType-dynamic').not('[data-hide*="' + value + '"]')
            if (el2) {
                el2.style.display = 'block'
            }
        } catch (e) {
            console.warn(e)
        }
    }
    const inputs = document.querySelectorAll('input[type=radio][name=registrationType]');
   
    for (const input of inputs) {
        if (input.checked) {
            switchInputs(input.value);
        }
        input.onchange = (e) => {
            switchInputs(e.target.value)
        }
    }
}

const lazyLoadUpdate = () => {
    lazyLoad?.update();
}

const offerSlideInit = async () => {
    if (document.querySelector('.js-offerslider')) {
        const {offerSlider} = await import('./components/slick-slider/offer-slider');
        offerSlider();
    }
}

const testimonialsSliderInit = async () => {
    if (document.querySelector('.js-testimonials-slider')) {
        const {testimonialsSlider} = await import('./components/slick-slider/testimonials-slider');
        testimonialsSlider();
    }
}

const offerGallerySliderInit = async () => {
    if (document.querySelector('#offerGallery')) {
        const {offerGallerySlider} = await import('./components/slick-slider/offer-gallery-slider');
        offerGallerySlider();
    }
}

const topOfferSliderInit = async () => {
    if (document.querySelector('.js-top-offer')) {
        
        await topOfferSlider();
        lazyLoadUpdate();
    }
}

const offerGalleryNavigationSliderInit = async () => {
    if (document.querySelector('.js-offer-gallery-navigation')) {
        const {offerGalleryNavigationSlider} = await import('./components/slick-slider/offer-gallery-navigation-slider');
        offerGalleryNavigationSlider();
    }
}

const cdescWrapInit = async () => {
    if (document.querySelector('.cdesc-wrap')) {
        const {cdescWrap} = await import('./components/cdesc-wrap');
        cdescWrap();
    }
}

const initLazy = async () => {
    lazyLoad = await initLazyLoad();
}

const icoInputInit = async () => {
    if (document.querySelector('.ico-input')) {
        const {icoInput} = await import('./components/ico-input');
        icoInput();
    }
}

const formAjaxInit = async () => {
    const form = document.querySelector('form.ajax')
    if (form) {
        const {formInit} = await import('./components/form')
        formInit(form)
    }
}

const formAjaxNewsletterInit = async () => {
    const formNewsletter = document.querySelector('form.ajax-newsletter')
    if (formNewsletter) {
        const {formNewsletterInit} = await import('./components/form-newsletter')
        formNewsletterInit(formNewsletter)
    }
}

const formAjaxNewsletterSubmitInit = async () => {
    document.querySelector('form.form-newsletter').addEventListener('submit', (e) => {
        e.preventDefault();
        document.querySelector('.btn-onm').click()
    })
}

const formContactInit = async () => {
    const forms = document.querySelectorAll('*[data-form-subject]')
    if (forms.length) {
        const {formContact} = await import('./components/form-contact.js')
        formContact(forms)
    }
}

const onmButtonInit = async () => {
    const onmBtns = document.querySelectorAll('.btn-onm')
    if (onmBtns.length) {
        const {btnOnmInit} = await import('./components/btn-onm')
        btnOnmInit(onmBtns)
    }
}

const linkInit = async () => {
    const link = document.querySelector('.nav-link[data-toggle=showSubmenu]')
    if (link) {
        link.addEventListener('mouseenter', async () => {
            let {default: Collapse} = await import('bootstrap/js/dist/collapse')
            const bsCollapse = new Collapse(document.querySelector('#megaMenu'), {toggle: false});
            bsCollapse.show()
        })
    }
}

const headerWrapperInit = async () => {
    const headerWrapperEl = document.querySelector('.header-wrapper')
    if (headerWrapperEl) {
        const {headerWrapper} = await import('./components/header-wrapper')
        headerWrapper(headerWrapperEl)
    }
}

const tooltipInit = async () => {
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    if (tooltipTriggerList.length) {
        const {tooltip} = await import('./components/bootstrap/tooltip')
        tooltip(tooltipTriggerList)
    }
}

const toggleMapInit = async () => {
    if (document.querySelector('.js-toggle-map')) {
        const {toggleMap} = await import('./components/maps/toggle-map');
        toggleMap();
    }
}

const archiveSwitcherInit = async () => {
    if (document.querySelector('#archiveSwitcher')) {
        const {archiveSwitcher} = await import('./components/archive-switcher');
        archiveSwitcher();
    }
}

const mapSwitcherInit = async () => {
    if (document.querySelector('#mapSwitcher')) {
        const {mapSwitcher} = await import('./components/map-switcher');
        mapSwitcher();
    }
}

const headerSearchTogglerInit = async () => {
    const headerSearchTogglers = document.querySelectorAll('#headerSearch .js-toggler')
    if (headerSearchTogglers.length) {
        const {headerSearch} = await import('./components/header-search')
        headerSearch(headerSearchTogglers)
    }
}

const accountInit = async () => {
    if (document.querySelector('#account')) {
        const {accountToggle} = await import('./components/account-toggle');
        accountToggle();
    }
}

const faqInit = async () => {
    if (document.querySelector('.js-faq-content')) {
        const {faqContent} = await import('./components/faq-content');
        faqContent();
    }
}

const navbarInit = async () => {
    if (document.querySelector('#navbar')) {
        const {navbar} = await import('./components/navbar')
        navbar()
    }
}

const whisperInit = async () => {
    if (document.querySelector('.js-whisper')) {
        const {whisperContent} = await import('./components/whisper-content');
        whisperContent();
    }
}

const modal = async () => {
    if (document.querySelectorAll('[data-toggle="modal"]').length) {
        const {modalInit} = await import('./components/bootstrap/modal')
        modalInit()
    }
}

const dropdown = async () => {
    if (document.querySelectorAll('[data-toggle="dropdown"]').length) {
        const {dropdownInit} = await import('./components/bootstrap/dropdown.js')
        dropdownInit()
    }
}

const collapse = async () => {
    if (document.querySelectorAll('[data-toggle="collapse"]').length) {
        const {collapseInit} = await import('./components/bootstrap/collapse')
        collapseInit()
    }
}

const popover = async () => {
    if (document.querySelectorAll('[data-toggle="popover"]').length) {
        const {popoverInit} = await import('./components/bootstrap/popover')
        popoverInit()
    }
}

const monetizationGalleryInit = () => {
    
}

ready(async () => {
    try {
        initLazy();
        offerSlideInit();
        testimonialsSliderInit();
        offerGallerySliderInit();
        topOfferSliderInit();
        offerGalleryNavigationSliderInit();
        cdescWrapInit();
        registerSwitcher();
        icoInputInit();
        formAjaxInit()
        formAjaxNewsletterInit()
        formAjaxNewsletterSubmitInit()
        formContactInit()
        onmButtonInit()
        linkInit()
        headerWrapperInit()
        tooltipInit()
        toggleMapInit()
        archiveSwitcherInit()
        mapSwitcherInit()
        headerSearchTogglerInit()
        accountInit()
        faqInit()
        navbarInit()
        whisperInit()
        modal()
        dropdown()
        collapse()
        popover()
        monetizationGalleryInit()
    
        const initMap = async () => {
            var offersMap = document.getElementById('offersMap');
            if (offersMap) {
                const {initOffersMap} = await import('./components/maps/offers-map');
                initOffersMap(offersMap);
            }
        
            var baseMap = document.getElementById('map');
            if (baseMap) {
                const {initBaseMap} = await import('./components/maps/base-map');
                initBaseMap(baseMap);
            }
        }
        
        window.initMap = initMap;
    } catch (e) {
        console.error(e)
    }
});

